import React, { useState, useContext, createContext, useEffect } from "react";
import { CategoryServices } from "../services/CategoryServices";
import { useClientCity } from "./useClientCity";
import { useLanguage } from "./useLanguage";

// ** Utils Imports
// import { getTokenFromStorage } from "../utils";

// ** Hooks imports
// import { useAuth } from "./useAuth";

const categoriesContext = createContext();

export function ProviderCategories({ children }) {
  const categories = useProviderCategories();
  return (
    <categoriesContext.Provider value={categories}>
      {children}
    </categoriesContext.Provider>
  );
}

export const useCategories = () => {
  return useContext(categoriesContext);
};

function useProviderCategories() {
  const {language} = useLanguage()
  const {clientCity} = useClientCity()
  // ** State
  const [categories, setCategories] = useState({
    items: [],
    loading: true,
    error: false
  });



  // ** Get All Categoryies
  const getAllCategoies = (language) => {
    setCategories((prev) => ({ ...prev, loading: true }));
    // if (categories.items.length < 1) {
      CategoryServices.getAll()
        .then((res) => {
          const { data } = res;
          setCategories((prev) => ({ ...prev, items: [...data.data] }));
        })
        .catch((error) => {
          setCategories((prev) => ({ ...prev, error: true }));
        })
        .finally(() => {
          setCategories((prev) => ({ ...prev, loading: false }));
        });
    // }else{
    //   setCategories((prev) => ({ ...prev, loading: false }));
    // }
  };
  // ** Categories
  useEffect(() => {
    if (clientCity && Object.keys(clientCity).length > 0) {
      if (clientCity.id !== 0) {
        getAllCategoies();
      }
    }
    return () => {};
  }, [clientCity, language]);
  // Return State
  return {
    categories,
    getAllCategoies
  };
}
